module.exports = __webpack_public_path__ + "quilt-graphic.png";


//////////////////
// WEBPACK FOOTER
// ./theme/bananar/assets/AmplifyTheArts/quilt-graphic.png
// module id = 188
// module chunks = 0 1